import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextEdited.meta';

export type UseTrackCapturedTextEditedParams = {
  text_id: string;
  text: string;
  old_text: string;
};

export const useTrackCapturedTextEdited = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextEdited = useCallback(
    (params: UseTrackCapturedTextEditedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextEdited };
};
